import React, { useEffect, useState } from "react"
import { useDispatch } from 'react-redux'
import _ from "lodash"

import { Button, TextInputField } from "../helpers"
import { Dialog } from "primereact/dialog"
import { Divider } from "primereact/divider"
import Loading from "./Loading"

import { raiseToast } from '../services/redux/reducers/toast/toast'


const RenameBuyerInvoiceItems = (props) => {
    const dispatch = useDispatch()
    const {
        visibleRenameBuyerInvoiceItems,
        buyerReqWiseDispatchNoteItems,
        buyerPOItemWiseDispatchNoteItems,
        itemsGroupedBy,
        isLoading
    } = props
    
    const [renamedBuyerInvoiceItems, setRenamedBuyerInvoiceItems] = useState([])

    useEffect(()=>{
        if(visibleRenameBuyerInvoiceItems){
            setRenamedBuyerInvoiceItems([])
        }
    },[visibleRenameBuyerInvoiceItems])


    const handleInputChange = (event, item, selectedItemGroupById) => {
        let updatedProducts = []
        let relatedrenamedBuyerInvoiceItem = renamedBuyerInvoiceItems.find(eachRenamedProduct => eachRenamedProduct[itemsGroupedBy] === selectedItemGroupById)
        if (relatedrenamedBuyerInvoiceItem) {
            const updatedBuyerInvoiceItem = { ...relatedrenamedBuyerInvoiceItem, [event.target.name]: event.target.value }
            if (!updatedBuyerInvoiceItem.productName?.trim() && !updatedBuyerInvoiceItem.productSpecification?.trim()) {
                updatedProducts = renamedBuyerInvoiceItems.filter(
                    eachBuyerInvoiceItem => eachBuyerInvoiceItem[itemsGroupedBy] !== selectedItemGroupById
                )
            } else {
                updatedProducts = renamedBuyerInvoiceItems.map(eachBuyerInvoiceItem =>
                    eachBuyerInvoiceItem[itemsGroupedBy] === selectedItemGroupById ? updatedBuyerInvoiceItem : eachBuyerInvoiceItem
                )
            }
        } else {
            let newProduct = {
                materialId: item.materialId,
                [event.target.name]: event.target.value,
                buyerReqItemId: item.buyerReqItemId,
                buyerPOItemId: item.buyerPOItemId
            }
            updatedProducts = [...renamedBuyerInvoiceItems, newProduct]
        }

        setRenamedBuyerInvoiceItems(updatedProducts)
    }

    const handleOnclickCreatePreviewInvoice = async () => {
        const invalidrenamedBuyerInvoiceItems = renamedBuyerInvoiceItems.filter(product => {
            const trimmedProductName = product.productName?.trim()
            const trimmedProductSpecs = product.productSpecification?.trim()
    
            return (trimmedProductName && !trimmedProductSpecs) || (!trimmedProductName && trimmedProductSpecs)
        })

        if (invalidrenamedBuyerInvoiceItems.length > 0) {
            let materialIds = _.uniqBy(_.map(invalidrenamedBuyerInvoiceItems, "materialId"))
            return dispatch(raiseToast({severity:'warn', detail: `Please enter both Product Name and Product Specification for materialIds ${materialIds.join(", ")}`, life: 3000}))
        }

        const minLengthInvalidItems = renamedBuyerInvoiceItems.filter(product => {
            const trimmedProductName = product.productName?.trim() || ''
            const trimmedProductSpecs = product.productSpecification?.trim() || ''
            return (trimmedProductName && trimmedProductName.length > 0 && trimmedProductName.length < 3) ||
                   (trimmedProductSpecs && trimmedProductSpecs.length > 0 && trimmedProductSpecs.length < 3)
        })

        if (minLengthInvalidItems.length > 0) {
            let materialIds = _.uniqBy(_.map(minLengthInvalidItems, "materialId"))
            return dispatch(raiseToast({severity:'warn', detail: `Product Name and Product Specification must be at least 3 characters for materialIds ${materialIds.join(", ")}` }))
        }

        if (window.confirm("Are you sure you want to continue...?")) {
            props.handleSubmit(true, renamedBuyerInvoiceItems)
        }
    }

    const handleCloseRenameBuyerInvoiceItems = () => {
        setRenamedBuyerInvoiceItems([])
        props.setVisibleRenameBuyerInvoiceItems()
    }

    return (
        <Dialog className="" header="Rename Buyer Invoice Items" visible={visibleRenameBuyerInvoiceItems} style={{ width: '85vw', maxHeight: '90vh', minHeight: "35vh", backgroundColor: '#f8f8f8' }} onHide={() => handleCloseRenameBuyerInvoiceItems()}>
            <div className="flex flex-column justify-content-between px-2 py-0" style={{ height: "100%"}}>
                <div className="p-card px-1 py-1">
                    {
                        itemsGroupedBy === "buyerPOItemId" ? 
                            buyerPOItemWiseDispatchNoteItems?.map((eachBuyerPOItem, index) => {
                                let relatedRenamedProduct = renamedBuyerInvoiceItems.find(eachRenamedProduct => eachRenamedProduct.buyerPOItemId === eachBuyerPOItem.buyerPOItemId)
                                let productName = eachBuyerPOItem?.companyProdName ? eachBuyerPOItem?.companyProdName : eachBuyerPOItem?.productName
                                let productSpecification = eachBuyerPOItem?.companyProdSpec ? eachBuyerPOItem?.companyProdSpec : eachBuyerPOItem?.productSpecification
                                return (
                                    <>
                                        <div className="col-12 pb-0 rename-buyer-invoice-item" key={index}>
                                            <div className="flex flex-column md:flex-row justify-content-between">
                                                <div className="flex flex-column flex-grow-1 col-12 md:col-5 pt-0 px-0">
                                                    <div className="mb-2 ">
                                                        <span className="font-semibold">{eachBuyerPOItem?.materialId}</span><span> | {productName} | {productSpecification}</span>
                                                    </div>
                                                    <div className="flex flex-wrap row-gap-2 column-gap-4">
                                                        <span className=""><span className="font-medium">UOM:</span><strong> {eachBuyerPOItem?.UOM}</strong></span>
                                                        <span className=""><span className="font-medium">Unit Price:</span><strong> {eachBuyerPOItem.unitPrice}</strong></span>
                                                        <span className=""><span className="font-medium">Quantity:</span><strong> {eachBuyerPOItem.qty}</strong></span>
                                                        <span className=""><span className="font-medium">Total Amount:</span> <strong>{eachBuyerPOItem.totalAmount}</strong></span>
                                                    </div>
                                                </div>
                                                <Divider layout="vertical" className="hidden md:block" />
                                                <div className="flex flex-column flex-grow-1 col-12 md:col-7 md:mt-0 p-0 pr-3">
                                                    <div className="col-12 pt-0">
                                                        <TextInputField name="productName" labelText="Product Name" value={relatedRenamedProduct?.productName} onChange={(e) => handleInputChange(e, eachBuyerPOItem, eachBuyerPOItem.buyerPOItemId)} />
                                                    </div>
                                                    <div className="col-12 py-0 ">
                                                        <TextInputField name="productSpecification" labelText="Product Specification" value={relatedRenamedProduct?.productSpecification} onChange={(e) => handleInputChange(e, eachBuyerPOItem, eachBuyerPOItem.buyerPOItemId)} />
                                                    </div>
                                                </div>
                                            </div>
                                            {index !== buyerPOItemWiseDispatchNoteItems.length - 1 && (
                                                <hr style={{ height: '3px', backgroundColor: '#e5e7eb', border: 'none', margin: '0.5rem 0' }} />
                                            )}
                                        </div>
                                    </>
                                )
                            })
                            :
                            buyerReqWiseDispatchNoteItems?.map((eachBuyerReqItem, index) => {
                                let relatedRenamedProduct = renamedBuyerInvoiceItems.find(eachRenamedProduct => eachRenamedProduct.buyerReqItemId === eachBuyerReqItem.buyerReqItemId)
                                let productName = eachBuyerReqItem?.companyProdName ? eachBuyerReqItem?.companyProdName : eachBuyerReqItem?.productName
                                let productSpecification = eachBuyerReqItem?.companyProdSpec ? eachBuyerReqItem?.companyProdSpec : eachBuyerReqItem?.productSpecification
                                return (
                                    <>
                                        <div className="col-12 pb-0 rename-buyer-invoice-item" key={index}>
                                            <div className="flex flex-column flex-grow-1  md:flex-row justify-content-between">
                                            
                                                <div className="flex flex-column col-12 md:col-5 pt-0 px-0">
                                                    <div className="mb-2">
                                                        <span>{eachBuyerReqItem?.materialId}</span><span> | {productName} | {productSpecification}</span>
                                                    </div>
                                                    <div className="flex flex-wrap row-gap-2 column-gap-4">
                                                        <span className=""><span>UOM:</span> <strong>{eachBuyerReqItem?.UOM}</strong></span>
                                                        <span className=""><span>Unit Price:</span><strong> {eachBuyerReqItem.unitPrice}</strong></span>
                                                        <span className=""><span>Quantity:</span><strong> {eachBuyerReqItem.qty}</strong></span>
                                                        <span className=""><span>Total Amount:</span> <strong>{eachBuyerReqItem.totalAmount}</strong></span>
                                                    </div>
                                                </div>
                                                <Divider layout="vertical" className="hidden md:block" />
                                                <div className="flex flex-column flex-grow-1 col-12 md:col-7 md:mt-0 p-0">
                                                    <div className="col-10 pt-0">
                                                        <TextInputField name="productName" labelText="Product Name" value={relatedRenamedProduct?.productName} onChange={(e) => handleInputChange(e, eachBuyerReqItem, eachBuyerReqItem.buyerReqItemId)} />
                                                    </div>
                                                    <div className="col-10 py-0">
                                                        <TextInputField name="productSpecification" labelText="Product Specification" value={relatedRenamedProduct?.productSpecification} onChange={(e) => handleInputChange(e, eachBuyerReqItem, eachBuyerReqItem.buyerReqItemId)}/>
                                                    </div>
                                                </div>
                                            </div>
                                            {index !== buyerReqWiseDispatchNoteItems.length - 1 && (
                                                <hr style={{ height: '3px', backgroundColor: '#e5e7eb', border: 'none', margin: '0.5rem 0' }} />
                                            )}
                                        </div>
                                    </>
                                )
                            })
                    }
                </div>
                <div className='flex justify-content-end flex-row'>
                    <Button className="small-btn" label="Create Preview Invoice" onClick={()=>handleOnclickCreatePreviewInvoice()} />
                </div>
             </div>
            <Loading visible={isLoading} />
        </Dialog>
    )
}

export default RenameBuyerInvoiceItems